// extracted by mini-css-extract-plugin
export default {"container":"verify-student_container"};